function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
  fill: "#0077B5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.65899 7.41135C8.65899 8.1959 8.06844 8.82367 7.1202 8.82367H7.10282C6.18984 8.82367 5.59961 8.1959 5.59961 7.41135C5.59961 6.6102 6.20781 6 7.13813 6C8.06844 6 8.64134 6.6102 8.65899 7.41135ZM8.47992 9.93888V18.1097H5.76046V9.93888H8.47992ZM18.2872 18.1098L18.2874 13.4248C18.2874 10.9151 16.9458 9.74704 15.1562 9.74704C13.7124 9.74704 13.0659 10.5401 12.705 11.0965V9.93913H9.98521C10.0211 10.7058 9.98521 18.11 9.98521 18.11H12.705V13.5467C12.705 13.3025 12.7227 13.0589 12.7946 12.8841C12.9911 12.3962 13.4386 11.8911 14.1899 11.8911C15.1744 11.8911 15.5679 12.6403 15.5679 13.7384V18.1098H18.2872Z",
  fill: "white"
});

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.787f0fa8.svg";
export { ForwardRef as ReactComponent };